export default __webpack_public_path__ + "static/book1-a3df2c3085c7b267c5bd47e179fc4bfd.png";